import { state } from "./store";
import { computed } from "vue";
import useVuelidate from '@vuelidate/core';
import { required, email, numeric, alpha, minLength } from '@vuelidate/validators';

export function getStateFormUser() {

    const rules = computed(() => ({
        user: {
            informations: {
                firstname: { required, alpha },
                name: { required, alpha },
                birthday: { required },
                birthplace: { required },
            },
            contact: {
                email: { required, email },
                tel: { required, numeric, minLength: minLength(10) },
            },
            location: {
                addressLine1: { required },
                city: { required },
                country: { required },
                zipcode: { required, numeric }
            }
        },

    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v1: v$ }
}

export function getStateFormFormation() {

    const rules = computed(() => ({
        formation: {
            justification: { required }
        }
    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v2: v$ }
}

export const isError = (vInstance) => vInstance.$invalid && vInstance.$dirty;